import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-start" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "pi pi-chevron-left mr-1" }, null, -1)
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = { class: "ml-auto d-flex align-items-center" }
const _hoisted_5 = { class: "btn-stripped d-flex align-items-center" }
const _hoisted_6 = { class: "bt-icon bt-icon--sm mr-3 text-gray" }
const _hoisted_7 = { class: "btn-stripped d-flex align-items-center" }
const _hoisted_8 = { class: "bt-icon bt-icon--sm mr-3 text-gray" }
const _hoisted_9 = { class: "d-flex align-items-baseline justify-content-between" }
const _hoisted_10 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_11 = { class: "guest-list-and-details" }
const _hoisted_12 = {
  key: 0,
  class: "guest-details-tab__loader"
}
const _hoisted_13 = {
  key: 1,
  class: "no-guests text-center"
}
const _hoisted_14 = { class: "text-uppercase" }
const _hoisted_15 = {
  key: 0,
  class: "fs-18 text-gray"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Button = _resolveComponent("Button")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TabView = _resolveComponent("TabView")
  const _component_GuestItem = _resolveComponent("GuestItem")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_GuestDetailsEdit = _resolveComponent("GuestDetailsEdit")
  const _component_DialogAddGuest = _resolveComponent("DialogAddGuest")
  const _component_DialogInfo = _resolveComponent("DialogInfo")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", null, [
          _createVNode(_component_router_link, {
            to: _ctx.backLink,
            class: "fs-18 text-decoration-none text-gray"
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("general.backTo")) + ": " + _toDisplayString(_ctx.currentEntrancePlant.name), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("AppResourceEP.Guests")), 1)
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_ElDropdown, {
            trigger: "click",
            placement: "bottom-end",
            "popper-class": "el-dropdown__popper el-dropdown--context"
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_ElDropdownMenu, { style: {"width":"240px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElDropdownItem, {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleAddGuest(true)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode("button", _hoisted_5, [
                        _createVNode("span", _hoisted_6, [
                          _createVNode(_component_InlineSvgScoped, {
                            src: 
                                                require('@/assets/images/entrancePlants/guest-one-time.svg')
                                            ,
                            "aria-label": "icon-resident"
                          }, null, 8, ["src"])
                        ]),
                        _createVNode("span", null, _toDisplayString(_ctx.$t("AppResourceEP.ActionOneTime")), 1)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ElDropdownItem, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleAddGuest(false)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode("button", _hoisted_7, [
                        _createVNode("span", _hoisted_8, [
                          _createVNode(_component_InlineSvgScoped, {
                            src: 
                                                require('@/assets/images/entrancePlants/guest-periodic.svg')
                                            ,
                            "aria-label": "icon-guest"
                          }, null, 8, ["src"])
                        ]),
                        _createVNode("span", null, _toDisplayString(_ctx.$t("AppResourceEP.ActionPeriodic")), 1)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Button, { class: "p-button-rounded p-button-raised p-button--m" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("entrancePlant.addGuest")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode(_component_TabView, {
        class: "staff-list p-tabview--custom",
        onTabChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleTabClick($event)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TabPanel, {
            header: _ctx.$t('AppResourceEP.ActiveMessage')
          }, null, 8, ["header"]),
          _createVNode(_component_TabPanel, {
            header: _ctx.$t('AppResourceEP.ExpiredMessages')
          }, null, 8, ["header"])
        ]),
        _: 1
      })
    ]),
    (_ctx.guestsList.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_ElScrollbar, { class: "guests-list mt-2" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.guestsList, (guest, index) => {
                  return (_openBlock(), _createBlock(_component_GuestItem, {
                    class: ["mx-4 my-2", {
                        'selected-guest':
                            _ctx.guestSelected && _ctx.guestSelected.id === guest.id,
                    }],
                    key: index,
                    guest: guest,
                    onClick: ($event: any) => (_ctx.showGuestDetail(guest))
                  }, null, 8, ["guest", "class", "onClick"]))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode("div", null, [
              (_ctx.changingGuest)
                ? (_openBlock(), _createBlock("div", _hoisted_12, [
                    _createVNode(_component_ProgressSpinner)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.guestSelected && !_ctx.changingGuest)
                ? (_openBlock(), _createBlock(_component_GuestDetailsEdit, {
                    key: 1,
                    guestSelected: _ctx.guestSelected,
                    onDeleteGuest: _ctx.handleDeleteGuest,
                    onUpdateList: _ctx.handleUpdateList
                  }, null, 8, ["guestSelected", "onDeleteGuest", "onUpdateList"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_13, [
          _createVNode("h1", _hoisted_14, _toDisplayString(_ctx.$t("entrancePlant.noGuests")), 1),
          (_ctx.tabSelected === _ctx.GuestTab.active)
            ? (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(_ctx.$t("entrancePlant.hintNewGuest")), 1))
            : _createCommentVNode("", true)
        ])),
    _createVNode(_component_DialogAddGuest, {
      isOneTime: _ctx.isOneTime,
      isVisible: _ctx.isVisibleAddGuest,
      onHideDialog: _ctx.toggleAddGuest,
      onUpdateList: _ctx.handleUpdateList
    }, null, 8, ["isOneTime", "isVisible", "onHideDialog", "onUpdateList"]),
    _createVNode(_component_DialogInfo, {
      isVisible: _ctx.isVisibleMaxEntity,
      title: _ctx.$t('AppResource.Warning'),
      message: _ctx.$t('entrancePlant.popupMessageMaxGuestsReachedWarning'),
      onHideDialog: _ctx.toggleMaxEntity
    }, null, 8, ["isVisible", "title", "message", "onHideDialog"])
  ], 64))
}